export default __webpack_public_path__ + "ac9960c8f737ce6bb146166989b0da98.png";